import { useState } from "react";

function makeParticles(count) {
  return Array.from({ length: count }).map(() => ({
    left: Math.random() * 100,
    delay: Math.random() * 20,
    duration: 16 + Math.random() * 18,
    size: 1 + Math.random() * 2.5,
    opacity: 0.25 + Math.random() * 0.6,
  }));
}

/**
 * Lightweight floating particle layer — pure CSS animation,
 * particle positions are computed once via lazy state initializer.
 */
export default function Particles({ count = 30 }) {
  const [items] = useState(() => makeParticles(count));

  return (
    <div className="particles" aria-hidden="true">
      {items.map((p, i) => (
        <span
          key={i}
          style={{
            left: `${p.left}%`,
            animationDelay: `-${p.delay}s`,
            animationDuration: `${p.duration}s`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            opacity: p.opacity,
          }}
        />
      ))}
    </div>
  );
}
